import React from 'react';

function TableCell({content, classes, contentClasses, onClick}) {
    return <td
        onClick={onClick}
        className={`sl-font sl-font-medium sl-text-sm sl-text-center sl-text-gray-700 sl-py-12 sl-px-16  sl-px-2 ${classes ? classes : 'sl-min-w-33'}`}
    >
        <span className={contentClasses}>{content}</span>
    </td>;
}

export default TableCell;
